module.exports = __webpack_public_path__ + "img/fundingResolutionLogo3.1c540c1c.png";